import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const networkLinks = [
    { name: "Schedule", href: "/schedule" },
    { name: "On Demand", href: "/on-demand" },
    { name: "News", href: "/news" },
    { name: "Contact", href: "/contact" },
    { name: "Careers", href: "/careers" },
    { name: "Admin", href: "/login" }
  ];

  return (
    <footer 
      data-testid="footer"
      className="bg-black border-t border-white/10 safe-area-x"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      {/* Main Footer Row */}
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <img 
              src="/asn-logo-main.png" 
              alt="Antler Sports Network"
              className="h-10 w-auto"
              style={{ background: 'transparent' }}
            />
            <p className="text-zinc-500 text-sm">
              High School & Collegiate Sports Coverage
            </p>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Quick Links</h4>
            <nav className="space-y-2">
              {networkLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="block text-zinc-400 text-sm hover:text-orange-500 transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Contact</h4>
            <div className="space-y-3">
              <a 
                href="mailto:antlersportsnetwork@gmail.com" 
                className="flex items-center gap-2 text-zinc-400 text-sm hover:text-orange-500 transition-colors"
              >
                <Mail className="w-4 h-4" />
                antlersportsnetwork@gmail.com
              </a>
              <a 
                href="tel:+18178078753" 
                className="flex items-center gap-2 text-zinc-400 text-sm hover:text-orange-500 transition-colors"
              >
                <Phone className="w-4 h-4" />
                (817) 807-8753
              </a>
              <div className="flex items-center gap-2 text-zinc-400 text-sm">
                <MapPin className="w-4 h-4" />
                Arlington, Texas
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-10 pt-8 border-t border-white/5">
          <p className="text-zinc-600 text-xs">
            © {currentYear} Antler Sports Network. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-zinc-600 text-xs">
            <Link to="/privacy" className="hover:text-zinc-400 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-zinc-400 transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
